import { Fragment } from 'react'

import { ORGANIZATION_TAB_GROUPS, OrganizationTab } from './organization-tabs'

import { TabsList, TabsTrigger } from '@/components/ui/tabs'

/** underlined tab bar: manage tabs, then a labelled group of insights; render inside `<Tabs>` */
export const OrganizationTabBar = ({
  counts = {}
}: {
  /** shown next to the tab label once known */
  counts?: Partial<Record<OrganizationTab, number | undefined>>
}) => (
  <TabsList className="h-auto w-full justify-start gap-1 overflow-x-auto rounded-none border-b bg-transparent p-0">
    {ORGANIZATION_TAB_GROUPS.map((group) => (
      <Fragment key={group.label ?? 'manage'}>
        {group.label && (
          <span
            aria-hidden
            className="flex shrink-0 items-center gap-2 pl-3 pr-1 text-xs font-medium text-muted-foreground"
          >
            <span className="h-4 w-px bg-border" />
            {group.label}
          </span>
        )}
        {group.tabs.map((tab) => (
          <TabsTrigger
            className="gap-1.5 rounded-none border-b-2 border-transparent px-3 py-2 data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none"
            key={tab.value}
            value={tab.value}
          >
            {tab.label}
            {counts[tab.value] !== undefined && (
              <span className="rounded-full bg-muted px-1.5 text-xs tabular-nums text-muted-foreground">
                {counts[tab.value]}
              </span>
            )}
          </TabsTrigger>
        ))}
      </Fragment>
    ))}
  </TabsList>
)
